import { c as _c } from "react/compiler-runtime";
import { Button, Link } from "@opensea/next-ui-kit";
import { CenterAligned, classNames, Flex, FlexColumn, IconCallout, TextBody, TextHeading } from "@opensea/ui-kit";
import { useIsHydrated } from "@opensea/ui-kit/hooks";
import { EmptyStateImageStack } from "@/components/empty-state/EmptyStateImageStack";
const positionClassNames = "absolute inset-0";
const animationClassNames = classNames("transition delay-200 duration-1000 ease-out-quint");
export function EmptyStateStack(t0) {
  const $ = _c(39);
  const {
    title,
    description,
    cta,
    icon: IconComponent,
    showImageStack: t1,
    children,
    className,
    innerClassName,
    isSolanaProfile
  } = t0;
  const showImageStack = t1 === undefined ? true : t1;
  const isHydrated = useIsHydrated();
  let t2;
  if ($[0] !== cta) {
    t2 = cta && <Button onClick={cta.onClick} variant="secondary">{cta.label}</Button>;
    $[0] = cta;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const ctaButton = t2;
  let t3;
  if ($[2] !== className) {
    t3 = classNames("relative h-full overflow-hidden", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== innerClassName) {
    t4 = classNames(positionClassNames, "z-[2] size-full", innerClassName);
    $[4] = innerClassName;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== IconComponent) {
    t5 = IconComponent ? <IconCallout icon={IconComponent} size={48} variant="solid" /> : null;
    $[6] = IconComponent;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isSolanaProfile || $[9] !== showImageStack) {
    t6 = showImageStack ? <EmptyStateImageStack isSolanaProfile={Boolean(isSolanaProfile)} /> : undefined;
    $[8] = isSolanaProfile;
    $[9] = showImageStack;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== title) {
    t7 = title ? <TextHeading size="lg">{title}</TextHeading> : null;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== description) {
    t8 = description ? <TextBody color="text-secondary" size="md">{description}</TextBody> : null;
    $[13] = description;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== cta || $[16] !== ctaButton || $[17] !== isSolanaProfile) {
    t9 = cta?.href && !isSolanaProfile ? <Link href={cta.href} variant="unstyled">{ctaButton}</Link> : ctaButton;
    $[15] = cta;
    $[16] = ctaButton;
    $[17] = isSolanaProfile;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <FlexColumn className="items-center gap-6">{t5}{t6}{t7}{t8}{t9}</FlexColumn>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t4) {
    t11 = <CenterAligned className={t4}>{t10}</CenterAligned>;
    $[25] = t10;
    $[26] = t4;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const t12 = isHydrated ? "h-3/4" : "h-6";
  let t13;
  if ($[28] !== t12) {
    t13 = classNames(positionClassNames, "pointer-events-none z-0 w-full opacity-50 [mask-image:linear-gradient(to_bottom,black_theme(spacing.6),rgba(0,0,0,0.3)_50%,transparent)]", animationClassNames, "duration-2500", t12);
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== children) {
    t14 = <FlexColumn className="absolute top-0 left-0 w-full">{children}</FlexColumn>;
    $[30] = children;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <Flex className={t13}>{t14}</Flex>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t11 || $[36] !== t15 || $[37] !== t3) {
    t16 = <div className={t3}>{t11}{t15}</div>;
    $[35] = t11;
    $[36] = t15;
    $[37] = t3;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}